module.exports = __webpack_public_path__ + "static/media/illustration-agency-bill.a0e19bae.svg";